import {useContext, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {UPDATE_DESIGN_OPTIONS} from '~/common/fabric/reducers/fabricDesign/constants';
import {selectEditorDisabled} from '~/common/fabric/reducers/fabricDesign/selectors';
import {UyoControl} from '../CardEditor/actions/UyoControl/UyoControl';

export const ImageEditor = () => {
  const {activeObjects} = useContext(EventCreateContext);
  const dispatch = useDispatch();
  const editorDisabled = useSelector(selectEditorDisabled);

  useEffect(() => {
    const [activeObject] = activeObjects || [];
    if (activeObject?.type === 'uYOImage') {
      dispatch({type: UPDATE_DESIGN_OPTIONS, payload: {touched: true}});
    }

    return () => {
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {textAreaOpen: false},
      });
    };
  }, [activeObjects, dispatch]);

  return (
    <div className="card_editor">
      <div className="edit_box image-editor image-editor--scroll-y">
        <UyoControl editorDisabled={editorDisabled} />
      </div>
    </div>
  );
};
